
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, Anatomy, Do, Caution } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  Messages are <strong>meaningful information boxes</strong> used to bring
  something to the <strong>user's attention</strong> or to{' '}
  <strong>provide feedback</strong> to the user.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/Messages/Message2.jpg" alt="Anatomy of messages" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} mdxType="Anatomy" />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Icon`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The symbol to represent the type of message`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Heading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Type of message`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The button to exit/dismiss the message`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Message`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`A descriptive and concise message`}</strong>{`, indicative of the `}<strong parentName="td">{`system status`}</strong>{` and instructing users `}<strong parentName="td">{`how to proceed or recover`}</strong></td>
        </tr>
      </tbody>
    </table>
    <h2>{`Do's`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`keep the message succinct`}</strong>{` and include only valuable and relevant information`}</li>
      <li parentName="ul">{`provide `}<strong parentName="li">{`informative messages`}</strong>{` (polite & non-technical) that convey `}<strong parentName="li">{`purpose`}</strong>{` and what `}<strong parentName="li">{`actions users need to take`}</strong>{` next`}</li>
      <li parentName="ul"><strong parentName="li">{`use consistent messages`}</strong>{` for the same information/success/warning/error throughout your site`}</li>
    </ul>
    <h2>{`Don'ts`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`don't over use messages`}</strong>{` - users may ignore them and they can get in the way of a user completing their task`}</li>
      <li parentName="ul"><strong parentName="li">{`don't write messages in a way that can appear to blame the user`}</strong>{`. For example, instead of `}<em parentName="li">{`The postal code you entered is invalid`}</em>{`, the message `}<strong parentName="li">{`should say`}</strong>{` `}<em parentName="li">{`Please enter a valid postal code`}</em></li>
      <li parentName="ul"><strong parentName="li">{`don't use all uppercase text`}</strong></li>
    </ul>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`when there is an `}<strong parentName="li">{`essential piece of information`}</strong>{` that needs to be conveyed`}</li>
      <li parentName="ul"><strong parentName="li">{`information`}</strong>{` message: the user needs to know `}<strong parentName="li">{`critical information before continuing`}</strong>{` with their task`}</li>
      <li parentName="ul"><strong parentName="li">{`success`}</strong>{` message: the user has performed an `}<strong parentName="li">{`action which was successfully completed`}</strong></li>
      <li parentName="ul"><strong parentName="li">{`warning`}</strong>{` message: the user needs to know about the `}<strong parentName="li">{`potential dangers of completing their task`}</strong>{` (for example: "you are about replace/erase your data")`}</li>
      <li parentName="ul"><strong parentName="li">{`error`}</strong>{` message: the user tried to perform an `}<strong parentName="li">{`action that failed because of a problem`}</strong>{` (for example: a file could not be uploaded because it wasn't the correct type of file)`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`don't use for basic information which is not critical to the user's task. Include that on the page, not in a message`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;